import { Component, OnInit, Output, EventEmitter, Input, OnChanges, AfterContentInit } from '@angular/core';
import { DashboardView, ProblemType, SetProblemNeighborScope } from 'src/app/state-management';
import { Problem } from 'src/app/models/problem';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';

@Component({
    selector: 'app-map-list',
    templateUrl: './map-list.component.html',
    styleUrls: ['./map-list.component.scss'],
    standalone: false
})
export class MapListComponent implements OnInit, OnChanges {
  @Output() toggleHybridList = new EventEmitter<boolean>();
  @Output() problemDetailsEmitter = new EventEmitter<string>();
  @Output() toggleProblem = new EventEmitter<Problem>();
  @Output() viewLoaded = new EventEmitter<boolean>();
  @Input() dashboardView: DashboardView;
  @Input() problems: Problem[];
  @Input() noProblems: boolean;
  @Input() appView: string;
  showList = true;
  @Input() expandedProblem: Problem;
  @Input() problemTypes: Map<number, ProblemType>;
  @Input() isRecentsView: boolean;

  constructor(private store: Store<{}>, private router: Router) { }

  ngOnInit() {
  }

  ngOnChanges() {
    if (this.problems.length > 0 || this.noProblems === true) {
      this.viewLoaded.emit(true);
    }
  }

  onToggleProblem(problem: Problem) {
    if (this.expandedProblem === problem) {
      this.expandedProblem = null;
    } else {
      this.expandedProblem = problem;
    }

    this.toggleProblem.emit(problem);
  }

  goToProblem(problemNo: string) {
    const problemNeighborScope: string[] = [];
    this.problems.forEach(problem => problemNeighborScope.push(problem.problemNo));
    this.store.dispatch(new SetProblemNeighborScope({ problemNeighborScope: problemNeighborScope }));
    this.router.navigateByUrl('/problemdetails?ProblemNo=' + problemNo);
  }

  toDetails(problemNum: string) {
    this.problemDetailsEmitter.emit(problemNum);
  }

  toggleList() {
    this.showList = !this.showList;
    this.toggleHybridList.emit(this.showList);
  }

  getProblemTypeName(problemType_Id: number) {

    const problemType = this.problemTypes.get(problemType_Id);
    if (problemType) {
      return problemType.problemType_Name;
    } else {
      return '';
    }
  }
}
